<template>
<div class="container admin-users-page">
	<!-- Header con botón de retroceso y título alineados correctamente -->
	<div class="param-title-wrap d-flex align-items-center">
		<b-button class="page-back-btn mr-2" variant="link" @click="goBack">
			<font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" class="back-icon" />
		</b-button>
		<h2 >{{labels.title}}</h2>
	</div>

	<!-- Filtros principales - Estilo similar a Niif -->
	<div class="param-title-wrap niif-header">
		<div class="d-flex align-items-center w-100">
			<div class="filters-container d-flex align-items-center">
				<div class="filter-date-wrapper">
					<input 
						type="text" 
						v-model="selIdentificacion" 
						class="filter-date-input filter-select"
						:placeholder="labels.placeholderIdentificacion"
					/>
				</div>
				<div class="filter-date-wrapper">
					<input 
						type="text" 
						v-model="selNombre" 
						class="filter-date-input filter-select"
						:placeholder="labels.placeholderNombre"
					/>
				</div>
				<div class="filter-date-wrapper">
					<b-button
						class="consult-btn ml-2"
						@click="f_limpia_filtro()"
						:disabled="isLoadingCarga"
					>
						<font-awesome-icon :icon="['fas', 'filter']" class="mr-1" />
						{{ labels.limpiar }}
					</b-button>
				</div>
				<div class="filter-date-wrapper">
					<b-button
						class="consult-btn ml-2"
						@click="f_lee_contratos()"
						:disabled="isLoadingCarga"
					>
						<font-awesome-icon :icon="['fas', 'search']" class="mr-1" />
						{{ labels.consultar }}
					</b-button>
				</div>
			</div>
		</div>
	</div>


	<!-- Tabla SIEMPRE visible -->
	<div class="admin-table-block mt-4">
		<div class="admin-table-block mt-4" v-if="listContratos?.length">
			<CorporateDataTable v-if="fgl_tabla"
				:items="contratosTableItems"
				:fields="allFields"
				:filter-defs="tableFilterDefs"
				:labels="tableLabels"
				:default-per-page="10"
				:page-options="[10, 20, 50, 100]"
				:narrow="false"
				:table-min-height="500"
				:table-max-height="500"
			>
				<template #toolbar-actions>
				</template>
				<template #cell(cuotas)="data">
					<b-button
						style="background-color: #e5ac00; width: 30px; height: 30px;"
						class="md-fab md-primary"
						@click="modCuotas(data.item.id)" 
					>
						<i><font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs"/></i>
					</b-button>
				</template>
				<template #cell(activos)="data">
					<b-button
						style="background-color: #e5ac00; width: 30px; height: 30px;"
						class="md-fab md-primary"
						@click="modActivos(data.item.id)" 
					>
						<i><font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs"/></i>
					</b-button>
				</template>
				<template #cell(centros)="data">
					<b-button
						style="background-color: #e5ac00; width: 30px; height: 30px;"
						class="md-fab md-primary"
						@click="modCentros(data.item.id)" 
					>
						<i><font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs"/></i>
					</b-button>
				</template>
			</CorporateDataTable>
			<ModificacionAutomatica :modalModAutomatica="showModAutom" :infoContrato="detalleContrato" @cierraModal="cierraModal"></ModificacionAutomatica>
			<ModificacionDetalle v-if="showModManual" :modalModManual="showModManual" :dataContrato="detalleContrato" @cierraModal="cierraModal"></ModificacionDetalle>
		</div>
	</div>
</div>
</template>

<script>
import Contrato from '../../services/Contrato'; 
import Tercero from '../../services/Tercero'; 
import TipoContrato from '../../services/TipoContrato' 
// import Detalle from './Detalle.vue'; 
import ModificacionAutomatica from './ModificacionAutomatica.vue'; 
import ModificacionDetalle from './ModificacionDetalle.vue'; 
import CorporateDataTable from '../utils/CorporateDataTable.vue'; 

export default {
name: 'Consultar',
props: ['tipoModify'],
components : {
        ModificacionAutomatica,
        ModificacionDetalle,
        CorporateDataTable,
    },
data: () => ({
        listContratos : [],
        listTipoContrato : [],
        listTercero : [],
        listTipoAct : [],
        listActivo : [],
        detalleContrato : [],
        // showCreaContrato : false,
        // showDetalleContrato : false,
        // detailContrato : []
        showModManual : false,
	selIdentificacion : '',
	selNombre : '',
	isLoadingCarga : false,
	fgl_tabla:true,
	showModAutom:false
    }),
computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    noRow : "No hay registros",
                    nroContrato : "Contrato",
                    arrendador : 'Arrendador',
                    fechaActivacion : 'F Activación',
                    fechaInicial : 'Fecha Inicial',
                    fechaFinal : 'Fecha Final', 
                    tipoContrato : 'Tp Contrato',
                    valorContrato : 'Vr Contrato',
                    estado : 'Estato',
			title : "Modificacion de Contratos",
			placeholderIdentificacion : "Identificacion....",
			placeholderNombre : "Nombre....",

                }
            }else{
                return {
                    noRow : "There are not records",
                    nroContrato : "Contract number",
                    arrendador : 'Lessor',
                    fechaActivacion : 'Activation date',
                    fechaInicial : 'Strating date',
                    fechaFinal : 'End date',
                    tipoContrato : 'Contract type',
                    valorContrato : 'Contract value',
                    estado : 'State'
                }
            }
        },
        filteredRows() {
            // Devuelve cuántos registros hay luego de aplicar el filtro
            return this.listContratos?.filter(item => 
                item.nro_contrato.toString().includes(this.filtroContrato) 
            ).length 
        },
contratosTableItems() {
      return (this.listContratos || []).map((item) => ({
        ...item, 
	arrendador: this.showArrendador(item.identificacion),
	tipo_contrato_desc: this.showTipoContrato(item.tipo_contrato),
	valor_contrato: this.formatNumber(item.valor_contrato),
        check: item.check || false
      }));
},
allFields() {
	return [
		{ key: 'nro_contrato', label: this.labels.nroContrato, sortable: true, tdClass: 'nowrap-cell'},
		{ key: 'arrendador', label: this.labels.arrendador, sortable: true, tdClass: 'nowrap-cell'},
		{ key: 'tipo_contrato_desc', label: this.labels.tipoContrato, sortable: true },
		{ key: 'valor_contrato', label: this.labels.valorContrato, sortable: true },
		{ key: 'fecha_inicial', label: this.labels.fechaInicial, sortable: true },
		{ key: 'fecha_final', label: this.labels.fechaFinal, sortable: true },
		{ key: 'cuotas', label: this.labels.cuotas,  thClass: 'text-center', tdClass: 'text-center', sortable: false },
		{ key: 'activos', label: this.labels.activos,  thClass: 'text-center', tdClass: 'text-center', sortable: false },
		{ key: 'centros', label: this.labels.centros,  thClass: 'text-center', tdClass: 'text-center', sortable: false },
	];
},
tableFilterDefs() {
	return [
		{ key: 'nro_contrato', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar Numero Contrato...' : 'Filter Date...' },
		{ key: 'arrendador', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar Arrendador...' : 'Filter Nit...' },
	];
},
tableLabels() {
return {
        noRow: this.labels.empty,
        noMatches: this.$store.state._language == "es-ES" ? "No se encontraron resultados" : "No results found",
        searchPlaceholder: this.$store.state._language == "es-ES" ? "Buscar en la tabla..." : "Search in table...",
        rowsPerPage: this.$store.state._language == "es-ES" ? "Filas por página:" : "Rows per page:",
        noSort: this.$store.state._language == "es-ES" ? "Sin orden" : "No sorting",
        sortAsc: this.$store.state._language == "es-ES" ? "A-Z / Menor a mayor" : "A-Z / Low to high",
        sortDesc: this.$store.state._language == "es-ES" ? "Z-A / Mayor a menor" : "Z-A / High to low",
        columns: this.$store.state._language == "es-ES" ? "Columnas" : "Columns",
        showAllColumns: this.$store.state._language == "es-ES" ? "Mostrar todas" : "Show all",
        filters: this.$store.state._language == "es-ES" ? "Filtros" : "Filters",
        clearFilters: this.$store.state._language == "es-ES" ? "Limpiar filtros" : "Clear filters",
      };
},
    },
    methods:{
	goBack() {
		this.$router.back()
	},

	cierraModal(){
                this.showModManual = false 
                this.showModAutom = false 
		this.fgl_tabla=true
	},
	f_lee_contratos() {
		Contrato.getAllContratos() 
		.then((res) => { 
			this.listContratos = res.data.listContratos 
			this.listContratos = this.listContratos.filter((c) => c.estado == "Inicial")
		})
		.catch((err) => console.log(err)) 
	},
	limpia_filtro() {
		this.selIdentificacion = ''
		this.selNombre = ''
	},
        filtrarPorContrato(item, filtro) {
            if (!filtro) return true
            const texto = filtro.toString().toLowerCase() 
            return item.nro_contrato.toString().toLowerCase()?.includes(texto) 
        },
        formatNumber(value) {
            return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 3 })?.format(value); 
        },
        modCuotas(id){
                this.showModManual = true 
                this.showModAutom = false 
		this.fgl_tabla=false
/*            if(this.tipoModify == 'Manual'){ 
                this.showModManual = true 
                this.showModAutom = false 
            }else{
                this.showModAutom = true 
                this.showModManual = false 
            }
*/

            Contrato.getContratoById(id) 
            .then((res) => { 
                // console.log(res.data.contractById[0]); 
                this.detalleContrato = res.data.contractById[0] 
            })
            .catch((err) => console.log(err)) 
        },
	showArrendador(identify){
		if	(identify == null || identify == undefined) {
			return identify
		}
  let nameTercero = this.listTercero.find((tercer) => tercer.identificacion === identify) 

		if	(nameTercero == undefined) {
			return "Tercero "+identify
		}
  return nameTercero?.nombre 
	},
	showTipoContrato(tipContrato){
		if	(tipContrato == null || tipContrato == undefined) {
			return tipContrato
		}
  let tipoContrato = this.listTipoContrato.find((tipoContact) => tipoContact.tipo_contrato === tipContrato) 
		if	(tipoContrato == undefined) {
			return "Tipo Contrato  "+tipoContrato
		}
  return tipoContrato?.descripcion 
	},
        closeModal(val){
            // this.showCreaContrato = val 
            // this.showDetalleContrato = val 
            this.showModAutom = val 
            this.showModManual = val 
        }
    },
    mounted(){
        Contrato.getAllContratos() 
        .then((res) => { 
            this.listContratos = res.data.listContratos 
            this.listContratos = this.listContratos.filter((c) => c.estado == 'Inicial') // Muestra solo los que son estado Inicial 
        })
        .catch((err) => console.log(err)) 

        Tercero.getAllTercero() 
        .then((res) => { 
            this.listTercero = res.data.listTercero 
        })
        .catch((err) => console.log(err)) 

        TipoContrato.getAllTipoContrato() 
        .then((res) => { 
            this.listTipoContrato = res.data.listTipoContrato 
        })
        .catch((err) => console.log(err)) 
    }
}
</script>
<style lang="css">
 .b-table-cell-container { 
		padding: 15px !important;
		max-width: 500px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
</style>
